import ApplicationController from './application_controller';

export default class extends ApplicationController {
  // Just do a full refresh instead of trying to figure out the JQuery nonsense.
  // -BW/RC 08/16/21
  afterChangeQbank(_element) {
    window.location.reload();
  }
}
